var _path, _path2, _path3, _mask, _g, _mask2, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 48,
    viewBox: "0 0 43 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86518 9.15651L18.6022 0.928625C22.5372 -0.860045 24.8983 -0.0730301 25.8284 3.36122C25.8284 8.2264 25.8284 14.0217 25.8284 20.8902C25.8284 24.5391 24.8267 26.9717 22.8234 28.2595C20.8201 29.5473 15.311 32.767 6.22457 37.9183C2.79033 39.2777 0.715468 38.133 0.0715468 34.5556C0 28.6172 -0.0715468 20.8902 0.143094 16.3112C0.21464 12.9485 1.78867 10.5874 4.86518 9.15651Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6586 12.1614L23.4671 3.93351C27.4022 2.14484 29.7633 2.93185 30.6934 6.3661C30.6934 11.2313 30.6934 17.0266 30.6934 23.8951C30.6934 27.544 29.6917 29.9765 27.6884 31.2644C25.6851 32.5522 20.1044 35.7718 11.018 40.9232C7.58374 42.2826 5.50888 41.1379 4.86496 37.5605C4.86496 31.6221 4.79342 23.8951 5.00806 19.3161C5.0796 15.9534 6.65363 13.5923 9.6586 12.1614Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4534 15.3811L29.262 7.15323C33.197 5.36456 35.5581 6.15158 36.4882 9.58583C36.4882 14.451 36.4882 20.2463 36.4882 27.1148C36.4882 30.7637 35.4865 33.1963 33.4832 34.4841C31.4799 35.772 25.8993 38.9916 16.8128 44.1429C13.3786 45.5023 11.3037 44.3576 10.6598 40.7802C10.6598 34.8419 10.5167 27.1148 10.8029 22.5358C10.8744 19.2446 12.4485 16.8836 15.4534 15.3811Z",
    fill: "url(#paint2_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 9,
    width: 27,
    height: 39
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6318 9.50781H42.5318V48H16.6318V9.50781Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.497 18.6663L35.234 10.4384C39.1691 8.64972 41.5301 9.43674 42.4602 12.871C42.4602 17.7362 42.4602 23.5315 42.4602 30.4C42.4602 34.0488 41.4586 36.4814 39.4553 37.7693C37.452 39.0571 31.9429 42.2767 22.8564 47.4281C19.4222 48.7875 17.3473 47.6427 16.7034 44.0654C16.6318 38.127 16.5603 30.3999 16.7749 25.821C16.8465 22.4583 18.4205 20.0972 21.497 18.6663Z",
    fill: "url(#paint3_linear)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 20,
    width: 15,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0843 20.4092V30.2826L23.7051 38.0097V28.1362",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2111 26.1328C27.068 26.2043 26.9249 26.3474 26.8534 26.4905C26.7103 26.7052 26.6388 26.8483 26.4241 27.2775L23.8484 34.79C23.7053 35.1477 23.6338 35.4339 23.6338 35.6485C23.6338 35.9347 23.7053 36.0778 23.92 36.1493C24.1346 36.2209 24.3493 36.1493 24.7785 35.9347L26.9965 34.6469V34.933C26.9965 35.3623 26.9965 35.5054 27.068 35.6485C27.2111 35.8632 27.4258 35.8632 27.712 35.6485C27.9981 35.4339 28.2843 35.1477 28.3559 34.8615C28.4274 34.6469 28.4274 34.4322 28.4274 34.0029V33.7168L28.6421 33.5737C28.9998 33.359 29.1429 33.2875 29.286 33.0728C29.5006 32.8582 29.6437 32.5005 29.6437 32.1427C29.6437 31.785 29.5006 31.6419 29.286 31.6419C29.1429 31.6419 28.9998 31.7134 28.6421 31.9281L28.4274 32.0712V31.2842C28.4274 30.8549 28.4274 30.7118 28.3559 30.5687C28.2128 30.3541 27.9981 30.3541 27.712 30.4971C27.4258 30.7118 27.1396 30.998 27.068 31.2842C26.9965 31.4988 26.9965 31.7134 26.9965 32.1427V32.9297L25.494 33.7883L27.7835 27.206C27.9266 26.8483 27.9266 26.7052 27.9266 26.4905C27.9266 26.0612 27.5689 25.9182 27.2111 26.1328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 20,
    width: 15,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0843 20.4092V30.2826L23.7051 38.0097V28.1362",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9359 22.2691L31.861 23.4854C31.6464 23.6285 31.2887 23.7716 31.074 24.2009C30.8594 24.6302 30.8594 24.9879 30.8594 25.2025V32.6434C30.8594 32.9296 30.8594 33.2873 31.074 33.4304C31.2887 33.5735 31.6464 33.3589 31.861 33.2158L33.9359 31.9995C35.0806 31.3556 35.8677 30.497 36.5116 29.0661C37.0124 27.9213 37.0839 26.9197 37.0839 25.2741C37.0839 23.6285 37.0839 22.6984 36.5116 22.126C35.8677 21.6252 35.0806 21.6252 33.9359 22.2691ZM32.5765 31.1409V24.7732L33.8643 24.0578C34.4367 23.7 34.7944 23.7 35.0806 23.9147C35.3668 24.2009 35.4384 24.7732 35.4384 26.2757C35.4384 27.7782 35.4384 28.4221 35.0806 29.0661C34.7944 29.6384 34.4367 30.0677 33.8643 30.3539L32.5765 31.1409Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.64107,
    y1: 11.6277,
    x2: 24.304,
    y2: 26.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819,
    stopColor: "#7AC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 6.49244,
    y1: 14.6432,
    x2: 29.1547,
    y2: 29.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819,
    stopColor: "#7AC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 12.2666,
    y1: 17.8904,
    x2: 34.9291,
    y2: 33.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818991,
    stopColor: "#7AC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 18.2729,
    y1: 21.1375,
    x2: 40.9358,
    y2: 36.4238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819362,
    stopColor: "#7AC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7244,
    stopColor: "#6873FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6bb33c2d18a0fb88172ebad3234961d8.svg";
export { ForwardRef as ReactComponent };